import { render, staticRenderFns } from "./AA.vue?vue&type=template&id=5c1b69c0&scoped=true"
import script from "./AA.vue?vue&type=script&lang=js"
export * from "./AA.vue?vue&type=script&lang=js"
import style0 from "./AA.vue?vue&type=style&index=0&id=5c1b69c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b69c0",
  null
  
)

export default component.exports